import { GridModule, PaddingModule, SpacingModule } from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { ContentBlocksComponent } from './content-blocks.component';
import { TwoColBlockModule } from './two-col-block/two-col-block.module';
import { OneColBlockModule } from './one-col-block/one-col-block.module';
import { PipesModule } from '@shared/pipes/pipes.module';

@NgModule({
  declarations: [ContentBlocksComponent],
  imports: [
    TwoColBlockModule,
    OneColBlockModule,
    BrSdkModule,
    CommonModule,
    RouterModule,
    GridModule,
    PaddingModule,
    SpacingModule,
    PipesModule,
  ],
  exports: [ContentBlocksComponent],
  entryComponents: [ContentBlocksComponent],
})

/**
 * Content Blocks Module
 */
export class ContentBlocksModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Content Blocks': ContentBlocksComponent,
    };
  }
}
